<template>
    <div class="scenes-box">
        <p class="img-box">
            <img v-if="newForm.cover || (newForm && newForm.config && newForm.config.cover)" :src="newForm.cover || newForm.config.cover" alt="img" />
            <img v-else :src="$images.material.default" alt="img" />
        </p>
        <div class="title-box">
            <p class="title">
                <span class="name">当前场景：</span>
                <span class="value">{{newForm && newForm.name||'暂无'}}</span>
            </p>
            <p
                class="btn"
                @click="handleSelectScenes"
            >选择场景</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ScenesBox",
        props: {
            form: Object
        },
        watch: {
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form',vl)}
        },
        data () {
            return {
                newForm: this.form
            }
        },
        methods: {
            // 选中游戏场景
            handleSelectScenes() {
                this.$toWebMessage({
                    type: 'EditResource',
                    value: {type: "editScenes", value: this.$store.state.editGameConfig.scenesData.categoryId},
                    callback: { type:'EditGameConfig', path: '/scenesData', operation: 'REPLACE'}
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.scenes-box{
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .img-box{
        width: 243px;
        height: 137px;
        background-color: #eee;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        overflow: hidden;

        img{
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }
    .title-box{
        display: flex;
        margin-left: 20px;
        flex-direction: column;
        justify-content: space-between;

        .title{
            font-size:14px;
            font-weight:400;
            color:rgba(144,147,153,1);
            line-height:20px;
            margin-left: 10px;
            display: flex;
            flex-direction: column;

            .value{
                font-size:16px;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:22px;
                margin-top: 6px;
            }
        }
        .btn{
            width:88px;
            text-align: center;
            height:34px;
            line-height: 34px;
            background:rgba(255, 120, 56,1);
            border-radius:4px;
            font-size:14px;
            font-weight:500;
            color:rgba(255,255,255,1);
            cursor: pointer;

            &:hover {
                opacity: .8;
            }
            &:active{
                opacity: .6;
            }
        }
    }
}
</style>
